import { PrivateRoute } from '../Routers/PrivateRoute'
import React from 'react'
import Users from '../Components/Admin/Catalogs/Users/List'
import UsersNew from '../Components/Admin/Catalogs/Users/Register'
import UsersPermissions from '../Components/Admin/Catalogs/Users/Permissions'
import Roles from '../Components/Admin/Catalogs/Roles/Roles'
import RolesNew from '../Components/Admin/Catalogs/Roles/RolesNew'
import RolePermissionsModulesDefault from '../Components/Admin/Catalogs/Roles/RolePermissionsModulesDefault'
import Modules from '../Components/Admin/Catalogs/Modules/Modules'
import ModulesNew from '../Components/Admin/Catalogs/Modules/ModulesNew'
import AppUsers from '../Components/Admin/Catalogs/AppUsers/AppUsers'
import AppUsersNew from '../Components/Admin/Catalogs/AppUsers/AppUsersNew'
import { UserProfileMain } from '../Components/Admin/Catalogs/Users/UserProfile/UserProfileMain'
//FORMS
import Forms from '../Components/Admin/Catalogs/Forms/Forms'
import FormsNew from '../Components/Admin/Catalogs/Forms/FormsNew'
import FormFields from '../Components/Admin/Catalogs/Forms/Fields/FormFields'
import FormFieldsNew from '../Components/Admin/Catalogs/Forms/Fields/FormFieldsNew'

//REPORTS
import Reports from '../Components/Admin/Catalogs/Reports/Reports'
import ReportsNew from '../Components/Admin/Catalogs/Reports/ReportsNew'

//REPORTS
import ReportsQueries from '../Components/Admin/Catalogs/ReportsQueries/ReportsQueries'

//TestPowerBi
import TestPowerBi from '../Components/Admin/Catalogs/TestPowerBi/TestPowerBi'

//BLOG POSTS
import BlogPosts from '../Components/BlogPosts/BlogPosts'
import BlogPostsNew from '../Components/BlogPosts/BlogPostsNew'

//CONFIG APP
import ConfigApp from '../Components/ConfigApp/ConfigApp'
import ConfigAppNew from '../Components/ConfigApp/ConfigAppNew'

//SURVEYS
import Surveys from '../Components/Surveys/Surveys'
import SurveysNew from '../Components/Surveys/SurveysNew'

//REPORT CREATED FROM WEB
import ReportWeb from '../Components/Admin/Catalogs/ReportWeb/ReportWeb'
import ReportWebNew from '../Components/Admin/Catalogs/ReportWeb/ReportWebNew'

//REPORT POWER BI
import { ReportPowerBI } from '../Components/Admin/Catalogs/ReportsPowerBI/ReportPowerBI'
//WaterStations
import WaterStations from '../Components/Admin/Catalogs/WaterStations/WaterStations'
import WaterStationsNew from '../Components/Admin/Catalogs/WaterStations/WaterStationsNew'
//PROVIDERS
import Providers from '../Components/Admin/Catalogs/Providers/Providers'
import ProvidersNew from '../Components/Admin/Catalogs/Providers/ProvidersNew'
//TRUCKS
import Trucks from '../Components/Admin/Catalogs/Trucks/Trucks'
import TrucksNew from '../Components/Admin/Catalogs/Trucks/TrucksNew'
//ROUTES
import RoutesTrucks from '../Components/Admin/Catalogs/RoutesTrucks/RoutesTrucks'

//WaterTruckRequest
import WaterTruckRequest from '../Components/Admin/Catalogs/WaterTruckRequest/WaterTruckRequest'
import WaterTruckRequestNew from '../Components/Admin/Catalogs/WaterTruckRequest/WaterTruckRequestNew'

//DashboardTechnicalWaterTruck
import DashboardTechnicalWaterTruck from '../Components/DashboardTechnicalWaterTruck/DashboardTechnicalWaterTruck'
import Conciliation from '../Components/Admin/Catalogs/Conciliation/Conciliation'
import ConciliationNew from '../Components/Admin/Catalogs/Conciliation/ConciliationNew'

//STATUS
import Status from '../Components/Admin/Catalogs/Status/Status'
import StatusNew from '../Components/Admin/Catalogs/Status/StatusNew'
import ReportsCounters from '../Components/Admin/Documents/ReportsCounters/ReportsCounters'

//Zones
import Zones from '../Components/Admin/Catalogs/Zones/Zones'
import ZonesNew from '../Components/Admin/Catalogs/Zones/ZonesNew'
//Processes
import ProcessesRequests from '../Components/Processes/Requests/ProcessesRequests'
import ProcessesRequestsNew from '../Components/Processes/Requests/ProcessesRequestsNew'
import ManageRequests from '../Components/Processes/Requests/ManageRequests/ManageRequests'
import ManageRequestsNew from '../Components/Processes/Requests/ManageRequests/ManageRequestsNew'

//UsersApp
import UsersApp from '../Components/Admin/Catalogs/UsersApp/UsersApp'
import UsersAppNew from '../Components/Admin/Catalogs/UsersApp/UsersAppNew'

//Repor HeatMap
import ReportsHeatMap from '../Components/Admin/Catalogs/ReportsHeatMap/ReportsHeatMap'
import ReportsCountersWaterTruckRequest from '../Components/Admin/Documents/ReportsCountersWaterTruckRequest/ReportsCountersWaterTruckRequest'
import ReportsCountersPipes from '../Components/Admin/Documents/ReportsCounters/ReportsCountersPipes'

import UsersRatings from '../Components/Admin/Catalogs/UsersRatings/UsersRatings'
import HumanResources from '../Components/Admin/Catalogs/HumanResources/HumanResources'
import HumanResourcesNew from '../Components/Admin/Catalogs/HumanResources/HumanResourcesNew'
//Employees
import Employees from '../Components/Admin/Catalogs/Employees/Employees'
import EmployeesNew from '../Components/Admin/Catalogs/Employees/EmployeesNew'
import ScheduleGroups from '../Components/Admin/Catalogs/Employees/Groups/ScheduleGroups'
import ScheduleGroupsNew from '../Components/Admin/Catalogs/Employees/Groups/ScheduleGroupsNew'
import EmployeesLogs from '../Components/Admin/Catalogs/Employees/Logs/EmployeesLogs'
import EmployeesLogsNew from '../Components/Admin/Catalogs/Employees/Logs/EmployeesLogsNew'

const moduleRoutesGenerator = (
  read,
  create,
  edit,
  imports,
  module,
  isAuth,
  client
) => {
  const components = {
    Users,
    UsersNew,
    UsersPermissions,
    Roles,
    RolesNew,
    RolePermissionsModulesDefault,
    Modules,
    ModulesNew,
    UserProfileMain,
    AppUsers,
    AppUsersNew,
    //FORMS
    Forms,
    FormsNew,
    FormFields,
    FormFieldsNew,
    //REPORTS
    Reports,
    ReportsNew,
    //REPORTS QUERIES
    ReportsQueries,
    //TestPowerBi
    TestPowerBi,
    //BLOG POSTS
    BlogPosts,
    BlogPostsNew,
    //CONFIG APP
    ConfigApp,
    ConfigAppNew,

    //SURVEYS
    Surveys,
    SurveysNew,

    //REPORT CREATED FROM WEB
    ReportWeb,
    ReportWebNew,

    //REPORT POWER BI
    ReportPowerBI,

    //Processes
    ProcessesRequests,
    ProcessesRequestsNew,
    ManageRequests,
    ManageRequestsNew,

    //WaterStations
    WaterStations,
    WaterStationsNew,
    //PROVIDERS
    Providers,
    ProvidersNew,
    //TRUCKS
    Trucks,
    TrucksNew,
    //ROUTES
    RoutesTrucks,

    //WaterTruckRequest
    WaterTruckRequest,
    WaterTruckRequestNew,

    //DashboardTechnicalWaterTruck
    DashboardTechnicalWaterTruck,

    //Conciliation
    Conciliation,
    ConciliationNew,
    //STATUS
    Status,
    StatusNew,

    //ReportsCounters
    ReportsCounters,
    // ReportsCountersPipes
    ReportsCountersPipes,

    //Zones
    Zones,
    ZonesNew,

    //UsersApp
    UsersApp,
    UsersAppNew,

    //ReportsHeatMap
    ReportsHeatMap,

    //ReportsCountersWaterTruckRequest
    ReportsCountersWaterTruckRequest,
    //UsersRatings
    UsersRatings,

    //HumanResources
    HumanResources,
    HumanResourcesNew,
    //Employees
    Employees,
    EmployeesNew,
    ScheduleGroups,
    ScheduleGroupsNew,
    EmployeesLogs,
    EmployeesLogsNew,
  }

  const routesArray = []
  if (read) {
    if (module?.module_info?.name === 'Drinks') {
      if (!client)
        routesArray.push(
          <PrivateRoute
            exact
            key={module.id}
            path={module?.module_info?.relative_link}
            component={components[module?.module_info?.name]}
            isAuth={isAuth}
          />
        )
    } else {
      routesArray.push(
        <PrivateRoute
          exact
          key={module.id}
          path={module?.module_info?.relative_link}
          component={components[module?.module_info?.name]}
          isAuth={isAuth}
        />
      )
    }
    routesArray.push(
      <PrivateRoute
        exact
        path={`${module?.module_info?.relative_link}/details/:id/:show`}
        component={components[`${module?.module_info?.name}New`]}
        isAuth={isAuth}
      />
    )
    if (module?.module_info?.name === 'ControlDeskRoutes') {
      routesArray.push(
        <PrivateRoute
          exact
          path={`${module?.module_info?.relative_link}/specificDetails/:id/:type`}
          component={components[`${module?.module_info?.name}Details`]}
          isAuth={isAuth}
        />
      )
    }
  }
  if (create) {
    routesArray.push(
      <PrivateRoute
        exact
        key={module.id}
        path={`${module?.module_info?.relative_link}/new`}
        component={components[`${module?.module_info?.name}New`]}
        isAuth={isAuth}
      />
    )
  }
  if (edit) {
    routesArray.push(
      <PrivateRoute
        exact
        key={module.id}
        path={`${module?.module_info?.relative_link}/edit/:id`}
        component={components[`${module?.module_info?.name}New`]}
        isAuth={isAuth}
      />
    )
  }
  if (imports) {
    routesArray.push(
      <PrivateRoute
        exact
        key={module.id}
        path={`${module?.module_info?.relative_link}/import/:form`}
        component={components[`${module?.module_info?.name}New`]}
        isAuth={isAuth}
      />
    )
  }
  return routesArray
}
export default moduleRoutesGenerator
